export function Home() {
  return (
    <div>
      <h1>Welcome!</h1>
      <ol>
        <li>Press Contacts to see and add contacts 📝.</li>
        <li>Press Appointments to see and add appointments 📅.</li>
      </ol>
    </div>
  );
}
